import { IRestrictBoardView } from "../common/api_interfaces/board/IRestrictBoardView";

export const hasRestrictedAccessColumn = (access: IRestrictBoardView, columnId: number, userEmail: string) => {
    const personRoleId = access.person.find((person) => person.email === userEmail)?.personRoleId;

    return access.boards.some((b) =>
        b.columns.some((c) => c.id === columnId && c.personRoleIds?.some((prId) => prId === personRoleId))
    );
};
export const hasRestrictedAccessBoard = (access: IRestrictBoardView, boardId: number, userEmail: string) => {
    const personRoleId = access.person.find((person) => person.email === userEmail)?.personRoleId;

    return access.boards.some((b) => b.id === boardId && b.personRoleIds?.some((prId) => prId === personRoleId));
};
